const PiscoContentTypes = {
    COVER_IMAGE: "CoverImage",
    VIDEO: "Video",
    CONTENT: "Content",
    BOTH: "Both",
}
export default PiscoContentTypes;
